import SideBar from "../../components/AdminDashboard/SideBar";
import Search from "../../components/AdminDashboard/Search";
import "../../styles/AdminDashboard/Settings.scss";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getAdminById, UpdateAdmin } from "../../apis/AdminDashboard/users";
import { useDispatch } from "react-redux";

const EditAdmin = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const params = useParams();
  const auth = useSelector((state) => state.auth);  


  const [loading, setLoading] = useState(false);
  const [adminData, setAdminData] = useState(null);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [permissionOption, setPermissionOptions]= useState("")
 
const [permissions, setPermissions] = useState([]);

  // Correct default states
const [selected, setSelected] = useState([]);
const [open, setOpen] = useState(false);


// Sync permissions with selected
useEffect(() => {
  setPermissions(selected);
}, [selected]);


  // const permissionOptions = [
  //   "Dashboard",
  //   "CCRT",
  //   "Voluntary Donation",
  //   "IOT Devices",
  //   "NDC’s",
  //   "User",
  //   "KYC Validation",
  //   "History",
  //   "Validators",
  //   "Settings",
  //   "Scheduling",
  //   "Request",
  //   "Account",
  // ];
const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "",
    department: "",
    selected:"",
    auth

  });
    const options = [
    "Dashboard",
    "CCRT",
    "Voluntary Donation",
    "IOT Devices",
    "NDC’s",
    "User",
    "KYC Validation",
    "History",
    "validators",
    "Settings",
    "scheduling",
    "Request",
    "Account",

  ];

  const toggleOption = (option) => {
    setSelected((prev) =>
      prev.includes(option)
        ? prev.filter((o) => o !== option) // remove
        : [...prev, option] // add
    );
  };
  useEffect(() => {
  setForm((prev) => ({ ...prev, permissions: selected }));
}, [selected]);

  // ✅ Fetch admin info by ID
  const fetchAdmin = async () => {
    try {
      const response = await getAdminById(params.id, auth?.token);
      const admin = response?.data?.data;
      setAdminData(admin);
      setFirstName(admin?.firstName || "");
      setLastName(admin?.lastName || "");
      setEmail(admin?.email || "");
      setPermissions(admin?.permissions || "");
      setRole(admin?.role || "");
    } catch (error) {
      console.error("Failed to fetch admin:", error);
      toast.error("Failed to load admin details");
    }
  };

  useEffect(() => {
    fetchAdmin();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const updatedData = {
      firstName,
      lastName,
      email,
      permissions,
    };
const editAdmin =  await UpdateAdmin(updatedData, auth?.token)
    console.log("Updated Admin:", editAdmin);

    if (editAdmin?.status === "success") {
      toast.success("Admin updated successfully!");
    } else {
      toast.error("Failed to update admin.");
    }
    // TODO: Call updateAdmin API here

    // 
    setLoading(false);
  };

  return (
    <div className="admin_settings flex">
      {/* Sidebar */}
      <div className="sidebar_container w-[250px]">
        <SideBar />
      </div>

      {/* Main */}
      <div className="main flex-1 px-10 py-6 bg-[#FAFAFA] min-h-screen overflow-y-auto">
        <Search />

        <h2 className="text-[24px] font-semibold text-[#101828] mb-8 mt-20">
          Settings
        </h2>

        {/* Header Cards */}
        <div className="flex gap-[33px] mb-8">
          {[
            {
              title: "Profile",
              description: "Update your personal details and picture",
              border: "border-[#E5E5E5]",
              Links: "/admin/admin-profile",
            },
            {
              title: "Password & Security",
              description: "See your password and update your password",
              border: "border-[#E5E5E5]",
              Links: "/admin/admin-password-and-security",
            },
            {
              title: "Team Access",
              description:
                "Control team accounts, assign roles, update details, and manage access securely.",
              border: "border-[#2C9963]",
              Links: "/admin/account-management-settings",
            },
          ].map((card, idx) => (
            <Link to={card.Links} key={idx}>
              <div
                className={`relative w-[356px] h-[167px] border ${card.border} rounded-[12px] p-6 hover:shadow-md transition`}
              >
                <div className="absolute left-6 top-[72px] flex flex-col gap-2 w-[314px]">
                  <h3 className="text-[24px] font-medium text-[#101828]">
                    {card.title}
                  </h3>
                  <p className="text-[14px] text-[#98A2B3]">{card.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Edit Section */}
        <div className="border border-[#667185] rounded-2xl w-[1150px] bg-white mt-10 p-12">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h2 className="text-lg font-semibold text-[#101828]">
                Update Admin Information
              </h2>
              <p className="text-[12px] text-[#667185] mb-5">
                Modify admin details, update role, and manage account access.
              </p>
            </div>
            <Link
              to="/admin/account-management-settings"
              className="flex items-center gap-2 px-8 py-4 rounded-xl bg-gradient-to-r from-[#038B47] to-[#00AED9] text-white text-[16px] font-semibold"
            >
              ← Back
            </Link>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="flex flex-col gap-6">
            <div className="grid grid-cols-2 gap-6">
              {/* First Name */}
              <div>
                <label className="text-[14px] text-[#667185]">First Name</label>
                <input
                  type="text"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="w-full border border-[#D0D5DD] text-[14px] rounded-lg px-4 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-[#00AED9]"
                />
              </div>

              {/* Last Name */}
              <div>
                <label className="text-[14px] text-[#667185]">Last Name</label>
                <input
                  type="text"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  className="w-full border border-[#D0D5DD] text-[14px] rounded-lg px-4 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-[#00AED9]"
                />
              </div>

              {/* Email */}
              <div className="col-span-2">
                <label className="text-[14px] text-[#667185]">Email</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border border-[#D0D5DD] text-[14px] rounded-lg px-4 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-[#00AED9]"
                />
              </div>



              {/* Role */}
              <div className="col-span-2">
                <label className="text-[14px] text-[#667185]">Role</label>
                <input
                  type="text"
                  value={role}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border border-[#D0D5DD] text-[14px] rounded-lg px-4 py-2 mt-1 focus:outline-none focus:ring-2 focus:ring-[#00AED9]"
                />
              </div>

{/* ✅ Permissions Multi-Select with Clickable Dropdown */}

            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="self-end px-8 py-3 bg-gradient-to-r from-[#038B47] to-[#00AED9] text-white rounded-lg mt-6 text-[15px] font-semibold hover:opacity-90 transition"
            >
              {loading ? "Updating..." : "Update Admin"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditAdmin;
